import React from 'react'
import CommonContainer from '../../components/shared/CommonContainer'
import { Box, Flex } from '@chakra-ui/react'
import ProfileDetails from '../../components/freelancer/dashboard/ProfileDetails'
import TabsHandler from '../../components/freelancer/dashboard/TabsHandler'
import Portfolio from '../../components/freelancer/dashboard/Portfolio'
import Certifications from '../../components/freelancer/dashboard/Certifications'
import WorkHistory from '../../components/freelancer/dashboard/WorkHistory'

export default function FreelancerDashboardPage() {
  return (
    <CommonContainer >
      <Box py={10}>
        <ProfileDetails />
        <TabsHandler />
      </Box>
      <Flex justifyContent={"space-between"} gap={{base:5,lg:10}} py={10} flexDir={{base:"column","2xl":"row"}}>
        <Box w={{"2xl":"60%"}}>
        <Portfolio />
        </Box>
        <Box w={{"2xl":"40%"}}>
          <Certifications />
          <WorkHistory />  
        </Box>

      </Flex>
    </CommonContainer>
  )
}
